/*
 * Client request (TASK-53790): once a visitor has interacted with the OneTrust
 * cookie consent banner (accept/reject/save preferences), the persistent
 * "reopen preferences" icon (#ot-sdk-btn-floating) moves into the footer
 * instead of floating over the page for the rest of its lifetime. CSS alone
 * can't do this — the SDK injects the button as a sibling of the page content,
 * not a footer descendant — so it's physically relocated here; _onetrust.css
 * switches it from `position: fixed` to `absolute` once it's inside [data-footer].
 * Hooks: [data-footer].
 */
;(function () {
  'use strict';

  function hasConsentInteraction() {
    return /(?:^|;\s*)OptanonConsent=/.test(document.cookie);
  }

  function relocate() {
    if (!hasConsentInteraction()) return;
    var btn = document.getElementById('ot-sdk-btn-floating');
    var footer = document.querySelector('[data-footer]');
    if (!btn || !footer || footer.contains(btn)) return;
    footer.appendChild(btn);
  }

  if (document.readyState !== 'loading') relocate();
  else document.addEventListener('DOMContentLoaded', relocate, { once: true });

  // Consent can be granted mid-session (this fires on the interaction), and the
  // SDK builds its floating button asynchronously — mirrors drawer-scrollbar.js's
  // bindOneTrust MutationObserver, which waits out the same SDK for the same reason.
  window.addEventListener('OneTrustGroupsUpdated', relocate);
  new MutationObserver(relocate).observe(document.body, { childList: true, subtree: true });
})();
